import { SubroutineSortType } from '@/types/subroutine';
import { createContext } from 'react';

type SubroutineContextType = {
  subroutineHistory: number[];
  clearSubroutineHistory: () => void;
  sortSubroutinesBy: SubroutineSortType;
  setSortSubroutinesBy: (newSortSubroutinesBy: SubroutineSortType) => void;
  selectedSubroutineId: number | undefined;
  setSelectedSubroutineId: (newSubroutineId: number | undefined, onBack?: boolean) => void;
};

export const SubroutineContext = createContext<SubroutineContextType>({
  subroutineHistory: [],
  clearSubroutineHistory: () => {},
  sortSubroutinesBy: 'default',
  setSortSubroutinesBy: () => {},
  selectedSubroutineId: undefined,
  setSelectedSubroutineId: () => {}
});
